import * as swcHelpers from '@swc/helpers';
import { MultiBancoFields } from '../models/details-order.js';

const toOrderDetailsPaymentInfo = (paymentDetails)=>{
    if (!paymentDetails || !paymentDetails.length) {
        return undefined;
    }
    const { paymentMethodDetails  } = paymentDetails[0];
    return paymentMethodDetails ? Object.entries(paymentMethodDetails).reduce((acc, [key, value])=>{
        if (key !== '__typename') {
            return swcHelpers.objectSpread({}, acc, {
                [MultiBancoFields[key] || key]: value
            });
        }
        return acc;
    }, {}) : undefined;
};
const toOrderDetailPrice = (raw)=>{
    return {
        totalPrice: raw.final.gross,
        shippingMethodPrice: raw.shippingCost.gross,
        paymentMethodPrice: raw.paymentCost.gross || 0,
        discountedAmount: raw.final.discount.amount || 0,
        subtotalAmount: raw.final.subtotal || 0,
        taxAmount: raw.final.tax.amount || 0
    };
};
const toAddress = (raw)=>{
    if (!raw) {
        return undefined;
    }
    const fieldNames = [
        'firstName',
        'lastName',
        'middleName',
        'additionalAddressInfo',
        'streetName',
        'salutation',
        'streetNumber',
        'additionalStreetInfo',
        'city',
        'title',
        'postalCode',
        'region',
        'pOBox',
        'state',
        'countryCode',
        'externalId',
        'company', 
    ];
    if (raw.__typename === 'OrderAddress') {
        return fieldNames.reduce((m, fieldName)=>{
            if (fieldName in raw) {
                var _fieldName;
                return swcHelpers.objectSpread({}, m, {
                    [fieldName]: (_fieldName = raw[fieldName]) !== null && _fieldName !== void 0 ? _fieldName : ''
                });
            }
            return m;
        }, {});
    }
};
const toCustomerDetails = (raw)=>{
    if (!raw) {
        return undefined;
    }
    const fieldNames = [
        'email',
        'phone',
        'dateOfBirth',
        'IBAN'
    ];
    if (raw.__typename === 'OrderCustomerDetails') {
        return fieldNames.reduce((m, fieldName)=>{
            if (fieldName in raw) {
                var _fieldName;
                return swcHelpers.objectSpread({}, m, {
                    [fieldName]: (_fieldName = raw[fieldName]) !== null && _fieldName !== void 0 ? _fieldName : ''
                });
            }
            return m;
        }, {});
    }
};
const toOrderDeliveryMethod = (raw)=>{
    if (!raw) {
        return undefined;
    }
    return raw.deliveryMethodName || '';
};
const toInvoice = (raw)=>{
    if (!raw) {
        return undefined;
    }
    return {
        customerCode: raw.code || undefined,
        secondaryEmail: raw.certifiedEmail || undefined,
        recipientCode: raw.certifiedRecipientCode || undefined,
        customerVatId: raw.vatId || undefined,
        insuranceProvider: raw.insuranceProvider || undefined,
        insuranceNumber: raw.insuranceNumber || undefined
    };
};
const toServiceStore = (raw)=>{
    if (!raw) {
        return undefined;
    }
    return {
        streetNumber: raw.streetNumber || undefined,
        streetName: raw.streetName || undefined,
        name: raw.name || undefined
    };
};

export { toAddress, toCustomerDetails, toInvoice, toOrderDeliveryMethod, toOrderDetailPrice, toOrderDetailsPaymentInfo, toServiceStore };
//# sourceMappingURL=orders.js.map
